import { Button, Tooltip, useToaster } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { TeacherIcon } from '@enterprise-ui/icons'
import apiConfig from '../../../config/'
import { SEARCH_ACTIONS } from '../../../constants/search'

const VOPActions = ({ selectedItems }) => {
  const toaster = useToaster()
  const selectedTcins = selectedItems?.map((item) => item.tcin, [])
  const redirectToVOPApp = async () => {
    try {
      const itemVOPBaseUrl = `${window.location.origin}`
      const itemVOPFullUrl = `${itemVOPBaseUrl}${apiConfig.itemVop.managePath}${selectedTcins}`
      window.open(itemVOPFullUrl, '_self', 'noopener,noreferrer')
    } catch (error) {
      toaster({
        type: 'error',
        heading: 'Error Redirecting to Casepack Application',
        message:
          error.message || 'An unknown error occurred while redirecting.',
      })
    }
  }

  const isItemVopButtonDisabled =
    selectedItems?.length !== 0 &&
    selectedItems?.length <= SEARCH_ACTIONS.MAX_EDITABLE

  return (
    <>
      <Tooltip
        content={
          selectedItems?.length <= SEARCH_ACTIONS.MAX_EDITABLE
            ? 'Manage Order Points'
            : 'Manage Order Points: Max 100'
        }
        location="top"
        data-testid="vop-tooltip"
      >
        <Button
          type="ghost"
          onClick={redirectToVOPApp}
          className="button-bg-hover-transparent"
          disabled={!isItemVopButtonDisabled}
          data-testid="casepack-button"
        >
          <EnterpriseIcon
            icon={TeacherIcon}
            size="md"
            className="hc-clr-contrast-weak"
          />
        </Button>
      </Tooltip>
    </>
  )
}

export default VOPActions
